import React from 'react';
import { IDRLinks, IMapTemplates, MapGroupProps, MapTemplate } from 'types';

// Map link items little pigs
import LittlePigsMathLink from 'components/common/digitalResourcesMaps/littlePigs/lessons/mathLink';
import LittlePigsLanguageArtsLink from 'components/common/digitalResourcesMaps/littlePigs/lessons/languageArtsLink';
import LittlePigsScienceLink from 'components/common/digitalResourcesMaps/littlePigs/lessons/scienceLink';
import LittlePigsArtLink from 'components/common/digitalResourcesMaps/littlePigs/lessons/artLink';
import LittlePigsMiscellaneousLink from 'components/common/digitalResourcesMaps/littlePigs/lessons/miscellaneousLink';
import LittlePigsSocialStudiesLink from 'components/common/digitalResourcesMaps/littlePigs/lessons/socialStudiesLink';
import LittlePigsTechnologySkillsLink from 'components/common/digitalResourcesMaps/littlePigs/lessons/technologySkillsLink';

import LittlePigsStaticElements from 'components/common/digitalResourcesMaps/littlePigs/map-bg';

import LittlePigsStaticRooms from 'components/common/digitalResourcesMaps/littlePigs/map-buttons';

// Map link items fantasy land
import FantasyLandMathLink from 'components/common/digitalResourcesMaps/fantasyLand/lessons/mathLink';
import FantasyLandLanguageArtsLink from 'components/common/digitalResourcesMaps/fantasyLand/lessons/languageArtsLink';
import FantasyLandScienceLink from 'components/common/digitalResourcesMaps/fantasyLand/lessons/scienceLink';
import FantasyLandArtLink from 'components/common/digitalResourcesMaps/fantasyLand/lessons/artLink';
import FantasyLandMiscellaneousLink from 'components/common/digitalResourcesMaps/fantasyLand/lessons/miscellaneousLink';
import FantasyLandSocialStudiesLink from 'components/common/digitalResourcesMaps/fantasyLand/lessons/socialStudiesLink';
import FantasyLandTechnologySkillsLink from 'components/common/digitalResourcesMaps/fantasyLand/lessons/technologySkillsLink';

import FantasyLandStaticElements from 'components/common/digitalResourcesMaps/fantasyLand/map-bg';

import FantasyLandStaticRooms from 'components/common/digitalResourcesMaps/fantasyLand/map-buttons';

// Map link items undersea
import UnderseaMathLink from 'components/common/digitalResourcesMaps/undersea/lessons/mathLink';
import UnderseaLanguageArtsLink from 'components/common/digitalResourcesMaps/undersea/lessons/languageArtsLink';
import UnderseaScienceLink from 'components/common/digitalResourcesMaps/undersea/lessons/scienceLink';
import UnderseaArtLink from 'components/common/digitalResourcesMaps/undersea/lessons/artLink';
import UnderseaMiscellaneousLink from 'components/common/digitalResourcesMaps/undersea/lessons/miscellaneousLink';
import UnderseaSocialStudiesLink from 'components/common/digitalResourcesMaps/undersea/lessons/socialStudiesLink';
import UnderseaTechnologySkillsLink from 'components/common/digitalResourcesMaps/undersea/lessons/technologySkillsLink';

import UnderseaStaticElements from 'components/common/digitalResourcesMaps/undersea/map-bg';

import UnderseaStaticRooms from 'components/common/digitalResourcesMaps/undersea/map-buttons';

// Map link items future city
import FutureCityMathLink from 'components/common/digitalResourcesMaps/future-city/lessons/mathLink';
import FutureCityLanguageArtsLink from 'components/common/digitalResourcesMaps/future-city/lessons/languageArtsLink';
import FutureCityScienceLink from 'components/common/digitalResourcesMaps/future-city/lessons/scienceLink';
import FutureCityArtLink from 'components/common/digitalResourcesMaps/future-city/lessons/artLink';
import FutureCityMiscellaneousLink from 'components/common/digitalResourcesMaps/future-city/lessons/miscellaneousLink';
import FutureCitySocialStudiesLink from 'components/common/digitalResourcesMaps/future-city/lessons/socialStudiesLink';
import FutureCityTechnologySkillsLink from 'components/common/digitalResourcesMaps/future-city/lessons/technologySkillsLink';

import FutureCityStaticElements from 'components/common/digitalResourcesMaps/future-city/map-bg';

import FutureCityStaticRooms from 'components/common/digitalResourcesMaps/future-city/map-buttons';

import { ResourcesType } from './resourcesMap';

export const mapStaticElements: IMapTemplates<React.FC> = {
  littlePigs: LittlePigsStaticElements,
  fantasyLand: FantasyLandStaticElements,
  undersea: UnderseaStaticElements,
  futureCity: FutureCityStaticElements,
  design5: FantasyLandStaticElements,
  design6: FantasyLandStaticElements,
  design7: FantasyLandStaticElements,
  design8: FantasyLandStaticElements,
};

export const mapStaticRooms: IMapTemplates<
  React.FC<{
    openLiteracyModal: (url: string) => void;
  }>
> = {
  littlePigs: LittlePigsStaticRooms,
  fantasyLand: FantasyLandStaticRooms,
  undersea: UnderseaStaticRooms,
  futureCity: FutureCityStaticRooms,
  design5: FantasyLandStaticRooms,
  design6: FantasyLandStaticRooms,
  design7: FantasyLandStaticRooms,
  design8: FantasyLandStaticRooms,
};

const littlePigsLinks: IDRLinks = {
  art: LittlePigsArtLink,
  languageArts: LittlePigsLanguageArtsLink,
  miscellaneous: LittlePigsMiscellaneousLink,
  math: LittlePigsMathLink,
  science: LittlePigsScienceLink,
  socialStudies: LittlePigsSocialStudiesLink,
  technologySkills: LittlePigsTechnologySkillsLink,
};

const fantasyLandLinks: IDRLinks = {
  art: FantasyLandArtLink,
  languageArts: FantasyLandLanguageArtsLink,
  miscellaneous: FantasyLandMiscellaneousLink,
  math: FantasyLandMathLink,
  science: FantasyLandScienceLink,
  socialStudies: FantasyLandSocialStudiesLink,
  technologySkills: FantasyLandTechnologySkillsLink,
};

const underseaLinks: IDRLinks = {
  art: UnderseaArtLink,
  languageArts: UnderseaLanguageArtsLink,
  miscellaneous: UnderseaMiscellaneousLink,
  math: UnderseaMathLink,
  science: UnderseaScienceLink,
  socialStudies: UnderseaSocialStudiesLink,
  technologySkills: UnderseaTechnologySkillsLink,
};

const futureCityLinks: IDRLinks = {
  art: FutureCityArtLink,
  languageArts: FutureCityLanguageArtsLink,
  miscellaneous: FutureCityMiscellaneousLink,
  math: FutureCityMathLink,
  science: FutureCityScienceLink,
  socialStudies: FutureCitySocialStudiesLink,
  technologySkills: FutureCityTechnologySkillsLink,
};

const DRLinks: IMapTemplates<IDRLinks> = {
  littlePigs: littlePigsLinks,
  fantasyLand: fantasyLandLinks,
  undersea: underseaLinks,
  futureCity: futureCityLinks,
  design5: fantasyLandLinks,
  design6: fantasyLandLinks,
  design7: fantasyLandLinks,
  design8: fantasyLandLinks,
};

export function getMapComponentByType(
  linkType: ResourcesType,
  mapTemplate: MapTemplate
): React.FC<MapGroupProps> {
  switch (linkType) {
    case ResourcesType.Art:
      return DRLinks[mapTemplate].art;
    case ResourcesType.LanguageArts:
      return DRLinks[mapTemplate].languageArts;
    case ResourcesType.Miscellaneous:
      return DRLinks[mapTemplate].miscellaneous;
    case ResourcesType.Math:
      return DRLinks[mapTemplate].math;
    case ResourcesType.Science:
      return DRLinks[mapTemplate].science;
    case ResourcesType.Social:
      return DRLinks[mapTemplate].socialStudies;
    case ResourcesType.Tech:
      return DRLinks[mapTemplate].technologySkills;
    default:
      return DRLinks[mapTemplate].miscellaneous;
  }
}
